/**
 * The left rail is closed while a tour runs. Closing it writes the person's
 * rail preference, so the tour leaves a marker and puts the rail back when it
 * ends, or from the home if the tab closed mid-tour.
 */

const MARKER = "co-tour-closed-rail";

function read(): boolean {
  try {
    return window.localStorage.getItem(MARKER) === "1";
  } catch {
    return false;
  }
}

function write(on: boolean) {
  try {
    if (on) window.localStorage.setItem(MARKER, "1");
    else window.localStorage.removeItem(MARKER);
  } catch {
    // No storage: the rail just stays where the tour left it.
  }
}

let releasing: number | undefined;

export function closeRail(
  railOpen: boolean,
  setRailOpen: (open: boolean) => void,
): void {
  // Still the tour's: it was only mounted again.
  window.clearTimeout(releasing);
  releasing = undefined;
  if (!railOpen) return;
  write(true);
  setRailOpen(false);
}

export function restoreRail(setRailOpen: (open: boolean) => void): void {
  if (!read()) return;
  write(false);
  setRailOpen(true);
}

/**
 * The tour lets go of the rail. Put back a moment later, so a tour that is
 * mounted again at once (a remount, React's strict mode) keeps it closed.
 */
export function releaseRail(setRailOpen: (open: boolean) => void): void {
  window.clearTimeout(releasing);
  releasing = window.setTimeout(() => {
    releasing = undefined;
    restoreRail(setRailOpen);
  }, 0);
}
